import { render } from "./GuidesElement.vue?vue&type=template&id=799f53d8"
import script from "./GuidesElement.vue?vue&type=script&lang=js"
export * from "./GuidesElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__